import { PureComponent } from 'react'
import ListItemLayoutView from './ListItemLayoutView'
import { ReactComponent as ClockIcon } from "../assets/clock.svg"
import { ReactComponent as PinIcon } from "../assets/pin.svg"
import { ReactComponent as QuoteIcon } from "../assets/quote.svg"

class ReportsListItem extends PureComponent {
    render () {
        const { report, reportPresentation, t, locale,
            isFirst, isLast, isOnly
        } = this.props

        const { imageSmallUrl, note } = report
        const hasImage = !!imageSmallUrl

        const icon = reportPresentation.getImageForReport(report)

        let title = reportPresentation.getTitleForReport(report)
        if (title) title = t(title)

        const subtitle = this.getReportSubtitle()

        const geolocationString = reportPresentation.getGeolocationStringForReport(report)

        const timeString = reportPresentation.getDateTimeStringForReport(report, locale)

        const hasNote = !!note
        const hasNotesText = t('SCREENS.REPORT_LIST.WITH_NOTE')
        const sourcePostfixKey = reportPresentation.getSourcePostfixKeyForReport(report)
        const postfix = sourcePostfixKey ? t(sourcePostfixKey) : ''
        const displayedNote = hasNote ? (postfix ? `${note} - ${postfix}` : note) : postfix
        const hasDisplayedNote = !!displayedNote
        const noteClass = hasDisplayedNote && hasImage ? 'reports-list-item__comments-indicator--overlay' : ''

        const showLineTop = !isOnly && !isFirst
        const showLineBottom = !isOnly && !isLast
        return (
            <ListItemLayoutView
                text={title}
                iconUrl={icon}
                isActive={false}
                showLineTop={showLineTop}
                showLineBottom={showLineBottom}
            >

                <p className="">
                    { timeString &&
                        <span>
                            <ClockIcon className="h-4 mr-2 inline-block text-gray stroke-current fill-current" />
                            { timeString }
                        </span>
                    }

                    { geolocationString &&
                        <span>
                            <PinIcon className="h-4 mx-2 ml-6 inline-block text-gray stroke-current fill-current" />
                            { geolocationString }
                        </span>
                    }
                </p>
                <h2 className="text-lg sm:text-xl py-2 font-bold">{title}</h2>
                {subtitle && <p className="">{subtitle}</p>}



                {   hasDisplayedNote &&
                        <div className={`media-right reports-list-item__comments-indicator ${noteClass}`}>
                            <QuoteIcon className="h-12 text-gray stroke-current fill-current" />
                            {hasNotesText}:
                            <div className="my-2">{displayedNote}</div>
                        </div>
                }
                {
                    hasImage &&
                        <div className="media-right">
                            <div className="reports-list-item__image">
                                <img src={imageSmallUrl} alt={title} />
                            </div>
                        </div>
                }
            </ListItemLayoutView>
        )
    }

    componentDidMount () {
      window.IconicJS().inject('.reports-list-item img.iconic')
    }

    getReportSubtitle () {
        const { reportPresentation, report, t } = this.props

        let subtitle = reportPresentation.getSubtitleForReport(report)
        if (!subtitle || subtitle.length === 0) return null

        subtitle = t(subtitle)
        if (!subtitle || subtitle.length === 0) return null
        return subtitle
    }
}

export default ReportsListItem
